export const VariantClasses = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
  italic: 'italic',
}

export const LeadingClasses = {
  none: 'leading-none',
  normal: '',
}

// line-clamp-<number>
export const ClampClasses = {
  clamp0: '',
  clamp1: 'line-clamp-1',
  clamp2: 'line-clamp-2',
  clamp3: 'line-clamp-3',
  clamp4: 'line-clamp-4',
  clamp5: 'line-clamp-5',
  clamp6: 'line-clamp-6',
  clamp7: 'line-clamp-7',
  clamp8: 'line-clamp-8',
  clamp9: 'line-clamp-9',
  clamp10: 'line-clamp-10',
}

export const SizeClasses = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
}

export const MarginClasses = {
  xs: 'mt-0 mb-2',
  sm: 'mt-0 mb-3',
  base: 'mt-0 mb-4',
  lg: 'mt-0 mb-4',
  xl: 'mt-0 mb-4',
}

export const ColorClasses = {
  gray300: 'text-gray-300',
  gray400: 'text-gray-400',
  gray500: 'text-gray-500',
  gray600: 'text-gray-600',
  gray700: 'text-gray-700',
  gray900: 'text-gray-900',
  red600: 'text-red-600',
  red700: 'text-red-700',
  red800: 'text-red-800',
  yellow600: 'text-yellow-600',
  yellow900: 'text-yellow-900',
  primary600: 'text-primary-600',
  green600: 'text-green-600',
  blue600: 'text-blue-600',
  white: 'text-white',
}
